<template>
  <div class="d-flex h-full flex-column">
    <TopAppBar
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="titleBrand"
        staticMode="true"
    >
    </TopAppBar>
    <div class="desktop-nav">
      <TopAppBarDrawer></TopAppBarDrawer>
      <div class="mdc-drawer-scrim transition"></div>
    </div>
    <main class="main-wrapper flex-grow-1">
      <div class="d-flex align-items-center mgl-12 mgr-12">
        <button class="material-icons  mdc-icon-button t-color-headlineBlack rtl-support" @click="$router.go(-1)">
          <div class="mdc-button__ripple"></div>
          arrow_back
        </button>
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m bg-white fix-header-title d-flex align-items-center justify-content-center flex-grow-1 mgr-48">
          {{ $t("1931") }}
        </div>
      </div>
      <div class="divider"></div>
      <div class="container container--narrow mgt-50">
        <label :class="isTextEmpty ? 'mdc-text-field--invalid' : ''"
               class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full"
               data-mdc-auto-init="MDCTextField">
          <textarea
              id="textarea"
              ref="msgRef"
              v-model="message"
              :class="isTextEmpty ? 'mdc-text-field--invalid' : ''"
              aria-labelledby="my-label-id"
              class="mdc-text-field__input t-body6 font-rn pdl-16 pdr-14 t-line-h-26 l-spacing2" cols="40" maxlength="1000" rows="8" >
          </textarea>
          <span class="mdc-notched-outline">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <label id="label" class="mdc-floating-label text-area-label">{{$t('1933')}}</label>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
        </label>
        <div id="my-counter-number" class="mdc-text-field-helper-line">
          <div
              class="mdc-text-field-helper-text t-color-textfieldError t-helper font-r opacity-1 l-spacing36 t-line-h-20 mdc-text-field-helper-text--validation-msg">
            <span v-show="isTextEmpty && messageLen">
              {{ $t('30222') }}
            </span>
          </div>
          <div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> 0 / 1000</div>
        </div>
        <div class="mgt-16 mgb-50">
          <label v-for="i in range(5)" :key="i" class="radio-wrapper-label">
            <div :class="[star_rating === i ? 'selected' : '']" class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4">
              <div class="mdc-form-field">
                <div class="mdc-radio customize-radio">
                  <input :id="`radio-${i}`" v-model="star_rating" :value="i" class="mdc-radio__native-control" name="radios" type="radio">
                  <div class="mdc-radio__background">
                    <div class="mdc-radio__outer-circle"></div>
                    <div class="mdc-radio__inner-circle"></div>
                  </div>
                  <div class="mdc-radio__ripple"></div>
                </div>
                <label :for="`radio-${i}`">
                  <i v-for="r in i" :key="r" class="material-icons t-color-starmark t-headline6 mgr-8 mgt-4">star</i>
                </label>
              </div>
            </div>
          </label>
        </div>
        <div class="mgb-50 pdb-50">
          <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8"  tabindex="0" @click.prevent="submitMessage" @keypress.prevent="submitMessage">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r">{{$t('1932')}}</span>
          </button>
          <button class="mdc-button bg-white t-color-secondaryBtnText mgr-8"  tabindex="0" @click.prevent="$router.go(-1)" @keypress.prevent="$router.go(-1)">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r">{{$t('3316')}}</span>
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/**
 * 리뷰 목록 컴포넌트(review list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import TopAppBar from "@/components/TopAppBar.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import microDegreeApi from "@/api/microDegreeApi";

export default {
  components: {
    TopAppBarDrawer,
    TopAppBar
  },

  data() {
    return {
      title: this.$t("863"),
      reviewData: [],
      message:'',
      textField: null,
      star_rating:null,
      submitState: false,
      totalPages: 1,
      currentPage: 1,
      reviewSummaryData: {},
      infiniteId: +new Date(),
      isNoData: false,
      textAreaError:'',
      titleBrand:localStorage.getItem('brandName'),
      isTextEmpty: false
    };
  },

  mixins: [topAppBarMixin],

  computed: {
    messageLen() {
      return this.message.length < 10
    }
  },

  mounted() {
     this.textField = new MDCTextField(document.querySelector('.mdc-text-field'))
     this.textField.value = this.message
  },

  methods: {
    range(n) {
      return [...Array(5).keys()].map((i) => i + 1);
    },

    submitMessage() {
      if (this.messageLen) {
        return this.isTextEmpty = true;
      }

      this.submitState = true;
      let params = {
        degreeId: this.$route.params.id,
        content: this.message,
        score: this.star_rating
      }
      this.textAreaError = this.message
      if(this.star_rating === null) {
        this.$snackOpen({contents: this.$t('3179'), btnDisplayYN: false}).then(() => {})
      } else {
        microDegreeApi.learnPostReview(params).then((response) => {
          this.$router.push({
            name: 'MicroCourseView',
            params: {
              degreeId: this.$route.params.id
            }
          });
        }).catch((err) => {
          console.log('err', err)
        });
      }
    },

    fetchData() {
      let params = this.setParams();
      microDegreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
        this.reviewSummaryData = response.data.data;
      }).catch((err) => {});
    },

    setParams() {
      const params = {
        degreeId: this.$route.params.id,
        page: this.currentPage,
      };
      return params;
    },
  },
};
</script>

<style scoped>
:root {
  --customColor1:var(--LectureRed);
  --customColor2: var(--LecturePurple);
  --customColor3:var(--LectureYellow);
  --customColor4:var(--LectureAqua);
}

.tabs .tab {
  width: 50%;
}

span.grade {
  color: var(--Iconinactive);
  font-size: 14px;
}

span.grade.big {
  color: var(--Iconinactive);
  font-size: 26px;
  padding-top: 8px;
  padding-right: 4px;
}

html[dir="rtl"] span.grade.big {
  padding-left: 4px;
}

span.grade.selected {
  color: var(--Starmark);
}

textarea.h-textearea {
  border-radius: 4px;
  border: solid 1px var(--Textfeildguid);
  height: 177px;
  resize: none;
  font-size: 14px;
  line-height: 1.57;
  font-weight: 400;
  box-sizing:border-box;
  width: 100%;
}

textarea.h-textearea::placeholder {
  color:var(--Iconinactive);
  font-size: 14px;
}

.custom-radio
.mdc-radio
.mdc-radio__native-control:enabled:checked
+ .mdc-radio__background
.mdc-radio__outer-circle {
  border-color:var(--WhiteHigh);
}

.custom-radio
.mdc-radio
.mdc-radio__native-control:enabled
+ .mdc-radio__background
.mdc-radio__inner-circle {
  border-color:var(--WhiteHigh);
}

.custom-radio
.mdc-radio
.mdc-radio__native-control:enabled:not(:checked)
+ .mdc-radio__background
.mdc-radio__outer-circle {
  border-color:var(--Iconinactive);
}

.custom-radio .mdc-radio__inner-circle {
  border-width: 12px;
}

.star-button {
  height: 54px;
  border-radius: 4px;
  background-color: var(--QuizGray);
}

.star-button.selected {
  background:var(--QuizBlack);
}

.mdc-radio::before, .mdc-radio::after{
  display: none;
}

.customize-input .mdc-floating-label {
  color: var(--Textfeildguid) !important;
}

.customize-input .mdc-floating-label--float-above {
  color: var(--Textfeildactive) !important;
  background-color: var(--DocumentWhite);
}

.customize-input.mdc-text-field--invalid .mdc-floating-label.mdc-floating-label--float-above {
  color: var(--Textfeilderror) !important;
}

.mdc-text-field--outlined.mdc-text-field--label-floating:not(.mdc-text-field--disabled)
.mdc-notched-outline__leading,
.mdc-text-field--outlined.mdc-text-field--label-floating:not(.mdc-text-field--disabled)
.mdc-notched-outline__notch,
.mdc-text-field--outlined.mdc-text-field--label-floating:not(.mdc-text-field--disabled)
.mdc-notched-outline__trailing {
  border-color:var(--Textfeildactive)!important;
}

.mdc-button--raised:not(:disabled), .mdc-button--unelevated:not(:disabled) {
  background-color: var(--SecondaryBtn);
}

.mdc-text-field--invalid .mdc-floating-label.mdc-floating-label--float-above {
  color: var(--Textfeilderror) !important;
}
</style>
